import { usePutApiUsersByIdMutation } from '@/model/user/api.generated';
import { useAppDispatch, useAppSelector } from '@/shared/hooks/useStore';
import { useTrans } from '@/shared/hooks/useTranslation';
import { selectUserData, setUser } from '@/viewmodel/features/user';
import { useAsyncMutation } from '@/viewmodel/shared/asyncMutation';

export function useSkipOnboarding(): {
  skipOnboarding: () => Promise<boolean | undefined>;
  isLoading: boolean;
} {
  const { t } = useTrans();
  const dispatch = useAppDispatch();
  const { data: user } = useAppSelector(selectUserData);
  const [putUser, { isLoading }] = usePutApiUsersByIdMutation();

  const skipOnboarding = useAsyncMutation(
    async (): Promise<boolean | undefined> => {
      if (!user?.id) return false;
      const result = await putUser({
        id: user.id,
        userUpdateUserRequest: { skip_onboarding: true },
      }).unwrap();
      if (result) {
        dispatch(setUser(result.data));
      }
      return !!result;
    },
    {
      logSource: 'useSkipOnboarding',
      logContext: 'Failed to dismiss onboarding',
      errorToast: t('onboarding.dismiss.error'),
      swallow: true,
    },
  );

  return { skipOnboarding, isLoading };
}
